import styled from 'styled-components';

export const ScoringTypeBlock = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;
